export default {
  whiteArrow: require('./white-arrow-infoblock.svg'),
};
